<template>
  <div>
    <el-dialog
      title="健康卡信息"
      v-alterELDialogMarginTop="{marginTop:'4vh'}"
      :visible.sync="cardVisible"
      width="68%"
      @close="closeDialog"
    >
      <div id="form">
        <div class="bidui">
          <div class="biduileft">
            <div class="tx">
              <img
                alt
                v-if="cardUser.photoPath!=undefined&&cardUser.photoPath!=''"
                :src="imgUrl+cardUser.photoPath"
              />
              <img alt v-else-if="cardUser.sex===0" src="@/assets/tx1.jpg" />
              <img alt v-else src="@/assets/tx4.jpg" />
              <label>{{cardUser.name}}</label>
            </div>
            <div class="title">基本信息</div>
            <div class="box">
              <ul class="viewul">
                <li>
                  <label>性别：</label>
                  {{cardUser.sex===1?'男':'女'}}
                </li>

                <li>
                  <label>身份证号：</label>
                  {{cardUser.idCardNumber|filterCard}}
                </li>
                <li>
                  <label>单位：</label>
                  {{cardUser.tempCompanyName}}
                </li>
                <li>
                  <label>电话：</label>
                  {{cardUser.mobile}}
                </li>
              </ul>
            </div>

            <div class="title">健康卡</div>
            <div class="box">
              <template v-if="cardObj.length>0" v-for="(model,index) in cardObj" :v-bind="index">
                <template v-if="model.category!=3">
                  <p>Q：{{model.question}}</p>
                  <p>A：{{model.answer}}</p>
                </template>
                <template v-if="model.category===3">
                  <p>Q：{{model.question}}</p>
                  <p>
                    A：
                    <template v-if="model.answer">
                      <div class="demo-image__preview">
                        <el-image
                          style="width: 150px;"
                          :src="imgUrl+model.answer"
                          :preview-src-list="[imgUrl+model.answer]"
                        ></el-image>
                      </div>
                    </template>
                  </p>
                </template>
              </template>
            </div>
            <div class="title">行程码</div>
            <div class="box">
              <template v-if="XingChengMa">
                <div class="demo-image__preview">
                  <el-image
                    style="width: 150px;"
                    :src="imgUrl+XingChengMa"
                    :preview-src-list="[imgUrl+XingChengMa]"
                  ></el-image>
                </div>
              </template>
            </div>
            <div class="title">健康码</div>
            <div class="box">
              <template v-if="JianKangMa">
                <div class="demo-image__preview">
                  <el-image
                    style="width: 150px;"
                    :src="imgUrl+JianKangMa"
                    :preview-src-list="[imgUrl+JianKangMa]"
                  ></el-image>
                </div>
              </template>
            </div>
          </div>
          <div class="biduiright">
            <div class="tx">
              <img
                v-if="cardInfo.idCardPhoto"
                alt
                :src="'data:image/jpg;base64,'+cardInfo.idCardPhoto"
              />
              <img alt v-else-if="cardUser.sex===0" src="@/assets/tx1.jpg" />
              <img alt v-else src="@/assets/tx4.jpg" />
              <label>{{cardInfo.idCardName}}</label>
            </div>
            <div class="title">基本信息</div>
            <div class="box">
              <ul class="viewul">
                <li>
                  <label>性别：</label>
                  {{cardInfo.idCardSex}}
                </li>
                <li>
                  <label>身份证号：</label>
                  {{cardInfo.idCardNumber}}
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="btnbox">
          <button
            v-if="reservationModel.state!=6
            &&(cardUser.reject===undefined||cardUser.reject==='')"
            name="Abutton1"
            @click="to(1)"
            class="btn greenbtn"
          >放进</button>
          <button
            v-if="reservationModel.state!=6
            &&(cardUser.reject===undefined||cardUser.reject==='')"
            name="Abutton1"
            @click="to(0)"
            class="btn redbtn"
          >禁入</button>
          <button
            v-if="reservationModel.state!=6
            &&cardUser.reject==='1'&&(cardUser.leave===undefined||cardUser.leave==='')"
            name="Abutton1"
            @click="out()"
            class="btn greenbtn"
          >放出</button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  imgUrl, //图片路径,
  getCompaniesInfo, //获取人员信息
  GetReservationUserDtoById,
  GetReservationDtoById,
  saveTargetUserAccessInfo,
  saveEntourageUserAccessInfo,
  saveTargetUserLeaveInfo,
  saveEntourageUserLeaveInfo,
  userAuthentication, //认证
  getUserProfileInfoById //获取身份证信息
} from "@/api/api";
export default {
  data() {
    return {
      reservationModel: {},
      userId: "",
      user: JSON.parse(window.localStorage.user),
      imgUrl: imgUrl,
       cardUser: {},
      cardVisible: false, //显示健康卡弹出框
      cardObj: [], //健康卡json
      JianKangMa: "", //健康码
      XingChengMa: "", //行程码
      cardInfo: {
        idCardNumber: "",
        idCardName: "",
        idCardSex: "",
        idCardPhoto: ""
      }, //身份证信息
      timer: ""
    };
  },
  //超过8个字符隐藏后面的
  filters: {
    filterCard(value) {
      if (!value) return "";
      if (value.length > 10) {
        return value.replace(/^(.{4})(?:\d+)(.{4})$/, "$1******$2");
      }
      return value;
    }
  },
  methods: {
    getCardInfo() {
      if (window.localStorage.cardInfo) {
        var model = JSON.parse(window.localStorage.cardInfo);
        this.cardInfo.idCardNumber = model.cardno;
        this.cardInfo.idCardName = model.name;
        this.cardInfo.idCardSex = model.sex;
        this.cardInfo.idCardPhoto = model.photobase64;
        clearInterval(this.timer);
      }
    },
    //显示健康卡信息(type:0表示监听)
    oper(rId, uId) {
      this.cardInfo = {
        idCardNumber: "",
        idCardName: "",
        idCardSex: "",
        idCardPhoto: ""
      };
      this.cardUser= {};
      this.cardVisible=false; //显示健康卡弹出框
      this.cardObj= []; //健康卡json
      this.JianKangMa= ""; //健康码
      this.XingChengMa= ""; //行程码

      this.timer = setInterval(this.getCardInfo, 1000);
      var _this = this;
      getUserProfileInfoById({ params: { userId: uId } }).then(res1 => {
        if (res1.data.success) {
          if (res1.data.data.idCardNumber != undefined) {
            _this.cardInfo = res1.data.data;
            _this.cardVisible = false;
            _this.cardVisible = true;
          }
        }
      });

      //获取身份证信息
      GetReservationUserDtoById({
        params: { reservationId: rId, userId: uId }
      }).then(res => {
        if (res.data.success) {
          _this.cardUser = res.data.data;
          _this.cardVisible = false;
          _this.cardVisible = true;
        }
      });
      //查询预约单
      GetReservationDtoById({ params: { id: rId } }).then(res => {
        if (res.data.success) {
          _this.reservationModel = res.data.data;
          _this.cardVisible = false;
          _this.cardVisible = true;
        }
      });
      //查询人员健康卡信息
      getCompaniesInfo({ params: { userId: uId } }).then(res => {
        if (res.data.success) {
          if (res.data.data.feedBackContent === undefined) {
            //_this.$message.error("该人员健康卡信息为空");
          } else {
            var obj = JSON.parse(res.data.data.feedBackContent);
            _this.cardObj = [];
            obj.forEach(element => {
              if (element.question.indexOf("健康") > -1) {
                _this.JianKangMa = element.answer;
              } else if (element.question.indexOf("行程") > -1) {
                _this.XingChengMa = element.answer;
              } else {
                _this.cardObj.push(element);
              }
            });
            _this.cardVisible = false;
            _this.cardVisible = true;
          }
        }
      });
    },
    to(reject) {
      var _this = this;
      if (this.cardInfo.idCardNumber != undefined) {
        if (
          this.cardUser.realNameState === 0 &&
          this.cardInfo.idCardNumber != undefined &&
          this.cardInfo.idCardNumber != ""
        ) {
          var para = {
            userId: this.cardUser.id,
            idCardNumber: this.cardInfo.idCardNumber,
            idCardName: this.cardInfo.idCardName,
            idCardSex: this.cardInfo.idCardSex === "女" ? 0 : 1,
            idCardPhoto: this.cardInfo.idCardPhoto
          };
          userAuthentication(para).then(res => {
            if (res.data.success) {
            } else {
              _this.$message.error("提交失败！");
            }
          });
        }
        if (_this.reservationModel.visitorUserId === _this.cardUser.id) {
          //当前人员是预约人员
          var para1 = {
            reservationId: _this.reservationModel.id, //主键Id
            reject: reject, //已核实或未核实
            personId: _this.cardUser.id,
            doorId: _this.user.door.id
          };
          saveTargetUserAccessInfo(para1).then(res2 => {
            if (res2.data.success) {
              _this.cardVisible = false;
              window.sessionStorage.isLoadParaPage="true";
              _this.$emit("backFun", _this.reservationModel.id);
            }
          });
        } else {
          //当前人员是随行人员
          var para2 = {
            reservationId: _this.reservationModel.id, //主键Id
            reject: reject, //已核实或未核实
            personId: _this.cardUser.id,
            doorId: _this.user.door.id
          };
          saveEntourageUserAccessInfo(para2).then(res2 => {
            if (res2.data.success) {
              _this.cardVisible = false;
              window.sessionStorage.isLoadParaPage="true";
              _this.$emit("backFun", _this.reservationModel.id);
            }
          });
        }
      }
    },
    out() {
      var _this = this;
      if (this.reservationModel.visitorUserId === this.cardUser.id) {
        //当前人员是预约人员
        var para = {
          reservationId: _this.reservationModel.id, //主键Id
          leave: 1, //已核实或未核实
          personId: _this.cardUser.id
        };

        saveTargetUserLeaveInfo(para).then(res => {
          if (res.data.success) {
            _this.cardVisible = false;
            window.sessionStorage.isLoadParaPage="true";
            _this.$emit("backFun", _this.reservationModel.id);
          }
        });
      } else {
        //当前人员是随行人员
        var para = {
          reservationId: _this.reservationModel.id, //主键Id
          leave: 1, //已核实或未核实
          personId: _this.cardUser.id
        };
        saveEntourageUserLeaveInfo(para).then(res => {
          if (res.data.success) {
            _this.cardVisible = false;
            _this.$emit("backFun", _this.reservationModel.id);
          }
        });
      }
    },
    closeDialog() {
      window.localStorage.removeItem("cardInfo");
      this.$emit("backFun", this.reservationModel.id);
    }
  }
};
</script>

<style scoped>
@import "../../styles/css.css";
</style>


// WEBPACK FOOTER //
// src/components/fksys/healthCard.vue